import axios from "axios";
import AppConfig from "../config";
import { hasValue } from "../utils/commonFns";

const baseURL = `${AppConfig.API_URL}/BusinessOrg`;

const getOrgs = async (nameFilter) => {
  try {
    var url = `${baseURL}?`;
    if (hasValue(nameFilter)) url += `name=${nameFilter}&`;
    let { data } = await axios.get(`${url}`);
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const getOrgById = async (id) => {
  try {
    let { data } = await axios.get(`${baseURL}/${id}`);
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const addOrgs = async (org) => {
  try {
    //let { data } = await axios.post(`${baseURL}`, JSON.stringify(org));

    let { data } = await axios.post(`${baseURL}`, org, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const UpdateOrgs = async (org) => {
  try {
    // let { data } = await axios.put(`${baseURL}`, JSON.stringify(org));
    let { data } = await axios.put(`${baseURL}`, org, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const DeleteOrgs = async (id) => {
  try {
    let { data } = await axios.delete(`${baseURL}/${id}`);
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

export { getOrgs, getOrgById, addOrgs, UpdateOrgs, DeleteOrgs };
